export const GET_SETTINGS_REQUEST = 'GET_SETTINGS_REQUEST';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';
export const GET_SETTINGS_FAIL = 'GET_SETTINGS_FAIL';

export const SET_SETTINGS_IDLE = 'SET_SETTINGS_IDLE';
export const SET_SETTINGS_REQUEST = 'SET_SETTINGS_REQUEST';
export const SET_SETTINGS_SUCCESS = 'SET_SETTINGS_SUCCESS';
export const SET_SETTINGS_FAIL = 'SET_SETTINGS_FAIL';
